var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('safe-management',[_c('main-view',{scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('ui-menu-bar',{attrs:{"controller":_vm.menu_controller},on:{"collapse":_vm.changeCollapse,"changeComponent":_vm.changeTeamComponent}})]},proxy:true},{key:"body",fn:function(){return [(_vm.default_components === 'access_rule')?_c('access-rules'):_vm._e(),(
          _vm.default_components === 'apply' ||
          _vm.default_components === 'approve' ||
          _vm.default_components === 'reject'
        )?_c('web-resource-request-list',{attrs:{"request_list_typed":_vm.default_components}}):_vm._e()]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }